<template>
  <div class="flex justify-between align-center" @click="$emit('show-more')">
    <div class="user-box">
      <div class="user-box__avatar">
        <img :src="getAvatar" :alt="user.mail_address" />
      </div>
      <p class="user-box__name">{{ user.representative_name }}</p>
    </div>

    <button class="btn-dropdown">
      <img src="@/assets/images/dropdown-right.svg" alt="" />
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const user = computed(() => store.state.user.user);
/* eslint-disable global-require */
const getAvatar = computed(() => {
  return user.value.avatar ?? require('@/assets/images/avatar-menu.svg');
});
</script>

<style lang="scss" scoped>
.user-box {
  display: flex;
  align-items: center;
  &__avatar {
    width: 43px;
    height: 43px;
    margin-right: 10px;
    img {
      width: 100%;
    }
  }

  &__name {
    font-size: 16px;
    font-family: 'Hiragino';
    font-weight: 600;
    margin-bottom: 0;
  }
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.align-center {
  align-items: center;
}

.btn-dropdown {
  background: transparent;
  border: unset;
  width: 9px;
  height: 17px;
  padding: 0;
  img {
    width: 100%;
    display: block;
  }
}
</style>
